var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"match-result"},[(_vm.protest)?_c('span',{staticClass:"match-result__disput"},[_c('div',[_vm._v("Протест")])]):_c('span',{staticClass:"match-result__count",class:{
      'counter-empty': _vm.isEmptyScore
    },domProps:{"textContent":_vm._s(((_vm.score[0]) + " : " + (_vm.score[1])))}})])}
var staticRenderFns = []

export { render, staticRenderFns }